import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 6a1 1 0 0 1 1 1v6.5h11V7a1 1 0 1 1 2 0v15a1 1 0 1 1-2 0v-6.5H6V22a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1M26.833 11.557a1 1 0 0 1 .61 1.276L24.913 20H28.5v-3a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0v-3h-5a1 1 0 0 1-.943-1.333l3-8.5a1 1 0 0 1 1.276-.61"
    />
  </svg>
);
const SvgIconTextHFour = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTextHFour);
export default Memo;
